import ky from 'ky';
import { snakeCase } from 'lodash-es';
import { performRefresh } from './authorization/performRefresh';
import { getTokenFromStorage } from './tokenStorage';

type JSONLike = string | number | boolean | null | JSONLike[] | { [key: string]: JSONLike };

export function fromCamelCaseToSnakeCase(value: JSONLike): JSONLike {
  if (Array.isArray(value)) {
    return value.map((item) => fromCamelCaseToSnakeCase(item)) as JSONLike;
  }
  if (value !== null && typeof value === 'object') {
    const result: { [key: string]: JSONLike } = {};
    for (const [key, v] of Object.entries(value)) {
      result[snakeCase(key)] = fromCamelCaseToSnakeCase(v as JSONLike);
    }
    return result;
  }
  return value;
}

export function createClient() {
  return ky.create({
    prefixUrl: typeof window === 'undefined' ? process.env.FES_HOST : '/',
    timeout: 120000,
    fetch: (request, init) => {
      return globalThis.fetch(request, {
        ...init,
        credentials: 'include', // Include cookies for cross-origin requests
      });
    },
    retry: {
      limit: 0,
    },
    hooks: {
      beforeRequest: [
        (request) => {
          if (typeof window === 'undefined') {
            const token = getTokenFromStorage();
            if (token) {
              request.headers.set('Authorization', `JWT ${token}`);
            }
          }
        },
      ],
      afterResponse: [
        async (request, options, response) => {
          if (response.status === 401) {
            try {
              await performRefresh();

              return await ky(request, {
                ...options,
                headers: {
                  ...request.headers,
                },
              });
            } catch (e) {
              if (typeof window !== 'undefined') {
                localStorage.removeItem('token');
                localStorage.removeItem('refresh');
                window.location.href = '/auth/logout';
              }
            }
          }

          return response;
        },
      ],
    },
  });
}

export const api = createClient();

export const unauthorizedApi = ky.create({
  prefixUrl: typeof window === 'undefined' ? process.env.FES_HOST : '/',
  timeout: 30000,
});
